<template>
  <div class="select-calendar-and-interval--container shadow-card no-select">
    <div class="select-calendar-and-interval--calendar">
      <select-calendar
        :active="activeDates"
        :reset="resetCalendar"
        @selectDate="selectDate"
      ></select-calendar>
    </div>
    <div class="select-calendar-and-interval--intervals">
      <select-interval
        @selectTime="emitTime"
        :intervals="selectIntervals"
        :reset="resetIntervals"
      ></select-interval>
    </div>
  </div>
</template>

<script>
import SelectCalendar from "./SelectCalendar";
import SelectInterval from "./SelectInterval";
import journalRepository from "../../../../repositories/journal";

export default {
  name: "SelectCalendarAndInterval",
  components: { SelectInterval, SelectCalendar },
  data() {
    return {
      data: [],
      selectIntervals: [],
      resetCalendar: 0,
      resetIntervals: 0
    };
  },
  props: {
    staff: Number,
    duration: Number,
    rerender: Number,
    reset: Number,
    selectedServices: Array
  },
  watch: {
    rerender: function() {
      this.getSchedule();
    },
    reset: function() {
      // this.data = [];
      // this.resetCalendar = this.resetCalendar +1;
      this.resetIntervals = this.resetIntervals + 1;
      this.emitDate("");
      this.emitTime("");
    }
  },
  computed: {
    activeDates() {
      let result = [];
      for (let key in this.data) {
        result[result.length] = this.data[key]["date"];
      }
      return result;
    }
  },
  methods: {
    getServicesIds() {
      let result = {
        services: [],
        modifications: []
      };
      for (let key in this.selectedServices) {
        if(+this.selectedServices[key].modification_id === 0){
          result.services[result.services.length] = this.selectedServices[key].service_id;
        }else{
          result.modifications[result.modifications.length] = this.selectedServices[key].modification_id;
        }
      }
      return result;
    },
    getSchedule() {
      this.$store.dispatch("startPreloader");
      this.resetIntervals = this.resetIntervals + 1;
      this.emitDate("");
      this.emitTime("");
      this.selectIntervals = [];

      journalRepository.getIntervalsByDaycount({
        staff: this.staff,
        duration: this.duration,
        service_list: JSON.stringify(this.getServicesIds())
      }).then(resp => {
        this.data = resp.data;
        this.$store.dispatch("stopPreloader");
      }).catch(err => {
        this.$store.dispatch("addNotification", {
          text: err.response.data.message,
          time: 6,
          color: "danger"
        });
        this.$store.dispatch("stopPreloader");
      });
    },
    selectDate(val) {
      if (val) {
        for (let key in this.data) {
          let activeData = new Date(this.data[key].date);
          if (
            +activeData.getDate() === +val.day &&
            +activeData.getMonth() === +val.month &&
            +activeData.getFullYear() === +val.year
          ) {
            this.selectIntervals = this.data[key].intervals;
            this.emitDate(this.data[key].date);
            this.emitTime("");
          }
        }
      } else {
        this.selectIntervals = [];
      }
    },
    emitDate(date) {
      this.$emit("selectDate", date);
    },
    emitTime(time) {
      this.$emit("selectTime", time);
    }
  },
  created() {}
};
</script>

<style scoped lang="less">
.select-calendar-and-interval--calendar {
  width: 70%;
  margin: 0 auto;
}
.select-calendar-and-interval--intervals {
  width: 70%;
  margin: 40px auto 0 auto;
}
@media (max-width: 600px) {
  .select-calendar-and-interval--calendar {
    width: 99%;
  }
  .select-calendar-and-interval--intervals {
    width: 99%;
  }
}
</style>
